export const environment = {
    production: true,
    isE2e: false,
};
